import * as React from "react";
import {
  Text,
  View,
  Image,
  Button,
  FlatList,
  TouchableOpacity,
} from "react-native";
import { NavigationContainer, useTheme } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import { LinearGradient } from "expo-linear-gradient";

import Colors from "../utils/colors";
import * as firebase from "firebase";

// import stockData from '../stockData'

class HomeScreen extends React.Component {
  state = {
    // "Materials",
    // "Energy",
    // "Industrials",
    // "Consumer Discretionary",
    // "Consumer Staples",
    // "Health Care",
    // "Financials",
    // "Information Technology",
    // "Telecommunication Services",
    // "Utilities",
    // "Real Estate",
    industryList: [
      {
        name: "Energy",
        color: [Colors["Red"], Colors["LightRed"]],
      },
      {
        name: "Materials",
        color: [Colors["yellow"], Colors["LightYellow"]],
      },
      {
        name: "Industrials",
        color: [Colors["Green"], Colors["LightGreen"]],
      },
      {
        name: "Consumer Discretionary",
        color: [Colors["Blue"], Colors["LightBlue"]],
      },
      {
        name: "Consumer Staples",
        color: [Colors["Blue"], Colors["Teal"]],
      },
      {
        name: "Health Care",
        color: [Colors["Red"], Colors["LightRed"]],
      },
      {
        name: "Financials",
        color: [Colors["yellow"], Colors["LightYellow"]],
      },
      {
        name: "Information Technology",
        color: [Colors["Green"], Colors["LightGreen"]],
      },

      {
        name: "Utilities",
        color: [Colors["Blue"], Colors["Teal"]],
      },
      {
        name: "Real Estate",
        color: [Colors["Red"], Colors["LightRed"]],
      },
    ],
  };

  componentDidMount() {
    this.checkCompletedIndustries()
 
  }

  checkCompletedIndustries=()=>{
    firebase
    .database()
    .ref(
      "userPicks/" +
        firebase.auth().currentUser.uid +
        "/" +
        this.getPreviousMonday() +
        "/"
    )
    .once("value")
    .then((snapshot) => {
      const values = snapshot.val();
      let industryList = [...this.state.industryList];
      if (values!==null){
        Object.keys(values).forEach((industry) => {
          let obj = industryList.find((o, i) => {
            if (o.name === industry) {
              industryList[i] = {
                name: industry + " (completed)",
                color: ["#606060", "#707070"],
              };
              return true; // stop searching
            }
          });
        });
      }
    

      this.setState({
        industryList: industryList,
      });
    });
  }

  getPreviousMonday = () => {
    var prevMonday = new Date();
    prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));
    const getStringFormatOfDate = (date) => {
      var dd = String(date.getDate()).padStart(2, "0");
      var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date.getFullYear();

      let strDate = dd + "-" + mm + "-" + yyyy;
      return strDate;
    };
    return getStringFormatOfDate(prevMonday);
  };
  render() {
    const colors = this.props["theme"]["colors"];
    return (
    
        <FlatList 
          numColumns={2}
          data={this.state.industryList}
          ListHeaderComponent={
            <Text
              style={{
                color: colors.text,
                fontFamily: "ArialMT",
                fontSize: 20,
                position: "relative",
                textAlign: "center", // <-- the magic
                padding: 20,
              }}
            >
              Please pick an industry
            </Text>
          }
          renderItem={(item) => {
            return (
              <TouchableOpacity
                style={{
                  width: "42%",
                  margin: "4%",
                  justifyContent: "center",
                }}
                onPress={() => {
                  item["item"]["color"][0] !== "#606060"
                    ? this.props.navigation.navigate("Swiper", {
                        name: item["item"]["name"],
                        // data: item["item"]["name"],
                      })
                    : null;
                }}

                disabled={ item["item"]["color"][0] === "#606060"}
              >
                <LinearGradient
                  // Button Linear Gradient
                  colors={item["item"]["color"]}
                  style={{
                    height: 100,
                    margin: 5,
                    alignItems: "center",
                    borderRadius: 10,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      backgroundColor: "transparent",
                      fontSize: 20,
                      color: "black",
                    }}
                  >
                    {item["item"]["name"]}
                  </Text>
                  {/* <Image
                    style={{ width: 50, height: 50 }}
                    source={{
                      uri:
                        "http://assets.stickpng.com/images/59cfc4d2d3b1936210a5ddc7.png",
                    }}
                  /> */}
                </LinearGradient>
              </TouchableOpacity>
            );
          }}
          keyExtractor={(item, index) => "key" + index}
        />
    );
  }
}

export default function (props) {
  const theme = useTheme();

  return <HomeScreen {...props} theme={theme} />;
}
